// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__kFsbf","title":"ClientReferral_title__2TKrS","itemText":"ClientReferral_itemText__AsTKf"};